import { OutletProvider } from "./OutletContext";
import { StockProvider } from "./StockProvider";

// import { CustomerProvider } from "./CustomerContext";
// import { SparrowCreditProvider } from "./SparrowCreditContext";

import { FilterProvider } from "./FilterContext";

import { UrlProvider } from "./UrlContext";
import { AccountingSidebarProvider } from "./AccountingSidebarContext";

const Providers = ({ children }) => {
  return <>
    <OutletProvider>

      <UrlProvider>

        <StockProvider>

          <FilterProvider>

            <AccountingSidebarProvider>

              {/* <CustomerProvider>
              <SparrowCreditProvider> */}

              {children}

              {/* </SparrowCreditProvider>
            </CustomerProvider> */}

            </AccountingSidebarProvider>

          </FilterProvider>

        </StockProvider>

      </UrlProvider>

    </OutletProvider>
  </>
};

export default Providers;
